// extracted by mini-css-extract-plugin
export default {"container":"donationStatus_container__ZGjqo","fail":"donationStatus_fail__C-ykU","success":"donationStatus_success__UPIxr"};